/* Dubai-time availability for Little Celebrations. No browser-local timezone assumptions. */
(function (global) {
  'use strict';
  const HOUR = 3600000;
  const dubaiDate = ms => new Date(ms + 4 * HOUR);
  const dayString = ms => dubaiDate(ms).toISOString().slice(0, 10);
  const slotTime = (date, hour) => Date.parse(date + 'T' + String(hour).padStart(2, '0') + ':00:00+04:00');
  const validDate = date => /^\d{4}-\d{2}-\d{2}$/.test(date) && !Number.isNaN(Date.parse(date + 'T00:00:00Z')) && new Date(date + 'T00:00:00Z').toISOString().slice(0, 10) === date;
  function cutoffOpen(now) {
    const local = dubaiDate(now), weekday = local.getUTCDay(), minutes = local.getUTCHours() * 60 + local.getUTCMinutes();
    return weekday >= 1 && weekday <= 4 ? minutes < 14 * 60 : (weekday === 5 || weekday === 6) && minutes < 12 * 60;
  }
  function minimumTime(now) {
    const local = dubaiDate(now), weekday = local.getUTCDay(), minutes = local.getUTCHours() * 60 + local.getUTCMinutes();
    const tomorrow = dayString(now + 24 * HOUR);
    if (weekday === 0) return slotTime(tomorrow, 12); // Sunday orders: Monday noon.
    if (weekday === 6 && minutes >= 16 * 60) return slotTime(dayString(now + 48 * HOUR), 12); // Saturday after 4: Monday noon.
    if (cutoffOpen(now)) return now + 4 * HOUR;
    if (weekday === 6) return now + 24 * HOUR; // Saturday noon to 4: Sunday with 24 hours' notice.
    return slotTime(tomorrow, 12); // Other late orders: next calendar day from noon.
  }
  function validSlot(date, hour, now = Date.now()) {
    if (!validDate(date) || !Number.isInteger(hour) || hour < 8 || hour > 20) return false;
    if (new Date(date + 'T00:00:00Z').getUTCDay() === 0 && hour < 12) return false;
    const today = dayString(now);
    if (date === today && !cutoffOpen(now)) return false;
    return slotTime(date, hour) >= minimumTime(now);
  }
  function hoursFor(date, now = Date.now()) {
    return Array.from({length: 13}, (_, i) => i + 8).filter(hour => validSlot(date, hour, now));
  }
  function sameDay(now = Date.now()) {
    return cutoffOpen(now) && hoursFor(dayString(now), now).length > 0;
  }
  const api = {dayString, cutoffOpen, minimumTime, validSlot, hoursFor, sameDay};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  global.CCLittleAvailability = api;
  if (typeof document !== 'undefined') {
    const refresh = () => document.querySelectorAll('[data-little-same-day]').forEach(el => { el.hidden = !sameDay(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
    setInterval(refresh, 30000);
  }
})(typeof window === 'undefined' ? globalThis : window);
